export default {
	title: 'safety',
	components: [
		{ title: 'obstacle_detection', component: 'obstacle_detection_g2' },
		{ title: 'safety_switch', component: 'safety_switch_g2' },
		{ title: 'max_power_protection', component: 'max_power_protection_g2' },
		{ title: 'max_voltage_protection', component: 'max_voltage_protection_g2' },
		{ title: 'max_current_protection', component: 'max_current_protection_g2' },
		{
			title: 'voltage_protection',
			component: 'voltage_protection_g2',
			min_ver: '0.13.0',
		},
	],
};
